module.exports = __webpack_public_path__ + "img/video-aulas.5befd704.png";